import businessClient from 'src/services/clients/business'
import { IMeta, ITag } from 'src/common/interfaces/index.js'

const ISettingsTagListResponse = { meta: IMeta, data: { list: [ITag] } }

export const settingsTag = {
  /**
   * @param {id: number} filter
   * @return {Promise<ISettingsTagListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('tags/portal/list', { filter }, { signal })
  },

  /**
   * @param {ITag} data
   * @return {Promise<ISettingsTagListResponse>}
   */
  upsert(data, signal) {
    return businessClient().post('tags/upsert', { data }, { signal })
  },

  /**
   * @param {id: number} filter
   * @return {Promise<ISettingsTagListResponse>}
   */
  archive(filter, signal) {
    return businessClient().post('tags/archive', { filter }, { signal })
  },
}
